import moment from "moment"

/**
 * Нормализует дату, поддерживая форматы DD.MM.YYYY и YYYY.MM.DD
 * @param {string|moment.Moment} date - Дата в любом из поддерживаемых форматов
 * @returns {moment.Moment} - Объект moment
 */
export const normalizeDate = (date) => {
    if (moment.isMoment(date)) return date
    // Попытка парсинга с несколькими форматами
    const parsedDate = moment(date, ['DD.MM.YYYY', 'YYYY.MM.DD', 'YYYY-MM-DD'], true)
    return parsedDate.isValid() ? parsedDate : moment(date)
}

export const getCurrentPeriodUtils = (periodList) => {
    if (!periodList?.length) return ''

    const now = moment()
    const period = periodList.find(({ term_begin, term_end }) => {
        const begin = normalizeDate(term_begin)
        const end = normalizeDate(term_end)
        return now.isBetween(begin, end, null, '[]')
    })

    return period?.trmid || ''
}

export const getCurrentYearUtils = (list, selectedDate) => { /// текущий год
    if (!list?.length) return ''

    // Подготовка и проверка selectedDate
    let date
    if (moment.isMoment(selectedDate)) {
        // Если уже moment объект
        date = selectedDate
    } else if (selectedDate) {
        // Если строка или другой формат
        date = normalizeDate(selectedDate)
    } else {
        // Если не передан, используем текущую дату
        date = moment()
    }

    // Попытка найти по датам (begdate и enddate)
    let year = list.find(({ begdate, enddate }) => {
        if (begdate && enddate) {
            const begin = normalizeDate(begdate)
            const end = normalizeDate(enddate)
            return date.isBetween(begin, end, null, '[]')
        }
        return false
    })

    // Если не найдено по датам, попытка найти по имени (формат "YYYY-YYYY")
    if (!year) {
        const currentYear = date.year()
        const currentMonth = date.month() + 1 // month() возвращает 0-11

        // Определяем учебный год: если месяц >= сентября (9), то это первая часть учебного года
        // иначе это вторая часть
        let academicYearStart, academicYearEnd
        if (currentMonth >= 9) {
            academicYearStart = currentYear
            academicYearEnd = currentYear + 1
        } else {
            academicYearStart = currentYear - 1
            academicYearEnd = currentYear
        }

        const yearName = `${academicYearStart}-${academicYearEnd}`

        year = list.find(({ name }) => name === yearName)
    }

    return year?.xp_key || ''
}

// Минуты от начала суток -> "HH:MM" (обратная операция к moment.duration(value).asMinutes())
export const minutesToTime = (minutes) => {
    if (minutes === undefined || minutes === null || minutes === '') return ''
    const total = Number(minutes)
    if (Number.isNaN(total)) return ''
    const hours = Math.floor(total / 60) % 24
    const mins = total % 60
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
}

// for school_weeks - trmid_list - даты могут не биться если выходят за пределы уч периодов = лето и тд
export const getCurrentTermUtils = (list, selectedDate) => {
    if (!list?.length) return ''

    const date = selectedDate ? normalizeDate(selectedDate) : moment()
    const year = list.filter(({ term_begin, term_end }) => {
        const begin = normalizeDate(term_begin)
        const end = normalizeDate(term_end)
        return date.isBetween(begin, end, null, '[]')
    })

    return year?.[0]?.trmid || ''
}
